var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z",
    fill: "#DEDFE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99573 1.25C10.456 1.25 10.8291 1.6231 10.8291 2.08333V2.91667C10.8291 3.3769 10.456 3.75 9.99573 3.75C9.53549 3.75 9.16239 3.3769 9.16239 2.91667V2.08333C9.16239 1.6231 9.53549 1.25 9.99573 1.25Z",
    fill: "#DEDFE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99573 16.25C10.456 16.25 10.8291 16.6231 10.8291 17.0833V17.914C10.8291 18.3742 10.456 18.7473 9.99573 18.7473C9.53549 18.7473 9.16239 18.3742 9.16239 17.914V17.0833C9.16239 16.6231 9.53549 16.25 9.99573 16.25Z",
    fill: "#DEDFE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24707 9.99866C1.24707 9.53842 1.62017 9.16532 2.0804 9.16532H2.91374C3.37397 9.16532 3.74707 9.53842 3.74707 9.99866C3.74707 10.4589 3.37397 10.832 2.91374 10.832H2.0804C1.62017 10.832 1.24707 10.4589 1.24707 9.99866Z",
    fill: "#DEDFE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2471 9.99866C16.2471 9.53842 16.6202 9.16532 17.0804 9.16532H17.911C18.3713 9.16532 18.7444 9.53842 18.7444 9.99866C18.7444 10.4589 18.3713 10.832 17.911 10.832H17.0804C16.6202 10.832 16.2471 10.4589 16.2471 9.99866Z",
    fill: "#DEDFE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80957 16.1849C3.48414 15.8594 3.48414 15.3318 3.80957 15.0064L4.39883 14.4171C4.72427 14.0917 5.2519 14.0917 5.57734 14.4171C5.90278 14.7426 5.90278 15.2702 5.57734 15.5956L4.98808 16.1849C4.66265 16.5103 4.13501 16.5103 3.80957 16.1849Z",
    fill: "#DEDFE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4162 5.57829C14.0907 5.25285 14.0907 4.72521 14.4162 4.39977L15.0035 3.81242C15.329 3.48698 15.8566 3.48698 16.182 3.81242C16.5075 4.13785 16.5075 4.66549 16.182 4.99093L15.5947 5.57829C15.2692 5.90372 14.7416 5.90372 14.4162 5.57829Z",
    fill: "#DEDFE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80957 3.81242C4.13501 3.48698 4.66265 3.48698 4.98808 3.81242L5.57734 4.40167C5.90278 4.72711 5.90278 5.25475 5.57734 5.58018C5.2519 5.90562 4.72427 5.90562 4.39883 5.58018L3.80957 4.99093C3.48414 4.66549 3.48414 4.13785 3.80957 3.81242Z",
    fill: "#DEDFE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4162 14.419C14.7416 14.0936 15.2692 14.0936 15.5947 14.419L16.182 15.0064C16.5075 15.3318 16.5075 15.8594 16.182 16.1849C15.8566 16.5103 15.329 16.5103 15.0035 16.1849L14.4162 15.5975C14.0907 15.2721 14.0907 14.7445 14.4162 14.419Z",
    fill: "#DEDFE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.746b67455d0adde7fe1348bf80972767.svg";
export { ForwardRef as ReactComponent };